import Loadable from '@townsquare/loadable';

export const AgentsViewLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "agents-view" */ './AgentsView'),
	loading: () => null,
});
